import { 
  FaUser, 
  FaBook, 
  FaGlobeAmericas, 
  FaBusinessTime, 
  FaBriefcase, 
  FaArrowRight 
} from 'react-icons/fa';
import { Link } from "react-router-dom";
import './sections.css';

function Sections() {
  return (
    <div className="container py-5">
      <div className="text-center mb-5 home-section-title">
        <h1 className="display-4">Servicios</h1>
        <p className="lead text-muted">
          Descubre nuestros servicios personalizados y orientados a tu éxito
        </p>
      </div>

      {/* Tarjeta de Empleos (única) */}
      <div className="row g-4 mb-4">
        <div className="col-12">
          <Link to="/empleos" className="text-decoration-none">
            <div className="card h-100 custom-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaBriefcase className="icon" />
                </div>
                <h2 className="home-section-title mt-3">
                  Empleos <FaArrowRight className="arrow-icon" />
                </h2>
                <p className="text-muted">
                  Descubre empleos que se ajustan a ti
                </p>
              </div>
            </div>
          </Link>
        </div>
      </div>

      {/* Cuatro tarjetas en 2x2 */}
      <div className="row g-4">
        {/* Asesoría Personalizada */}
        <div className="col-md-6">
          <Link to="/asesoria" className="text-decoration-none">
            <div className="card h-100 custom-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaUser className="icon" />
                </div>
                <h2 className="home-section-title mt-3">
                  Asesoría Personalizada <FaArrowRight className="arrow-icon" />
                </h2>
                <p className="text-muted">
                  Sesiones diseñadas para potenciar tu carrera, emprendimiento y crecimiento personal.
                </p>
                <ul className="list-unstyled custom-list">
                  <li>Asesoría Personal</li>
                  <li>Asesoría de Carrera</li>
                  <li>Asesoría de Emprendimiento</li>
                  <li>Mentoría y Liderazgo</li>
                </ul>
              </div>
            </div>
          </Link>
        </div>

        {/* Educación */}
        <div className="col-md-6">
          <Link to="/educate" className="text-decoration-none">
            <div className="card h-100 custom-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaBook className="icon" />
                </div>
                <h2 className="home-section-title mt-3">
                  Educación <FaArrowRight className="arrow-icon" />
                </h2>
                <p className="text-muted">
                  Recursos para desarrollar tus habilidades y crecer profesionalmente.
                </p>
                <ul className="list-unstyled custom-list">
                  <li>Guía Educativa</li>
                  <li>Validación de Crédito</li>
                  <li>Ofertas Educativas</li>
                </ul>
              </div>
            </div>
          </Link>
        </div>

        {/* Migración */}
        <div className="col-md-6">
          <Link to="/migration" className="text-decoration-none">
            <div className="card h-100 custom-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaGlobeAmericas className="icon" />
                </div>
                <h2 className="home-section-title mt-3">
                  Migración <FaArrowRight className="arrow-icon" />
                </h2>
                <p className="text-muted">
                  Facilita tu proceso de migración con nuestra ayuda.
                </p>
                <ul className="list-unstyled custom-list">
                  <li>Abogados aprobados por el Departamento de Justicia</li>
                  <li>Organizaciones comunitarias (CBOs) que ofrecen asesoramiento</li>
                </ul>
              </div>
            </div>
          </Link>
        </div>

        {/* Emprendimiento */}
        <div className="col-md-6">
          <Link to="/emprendimiento" className="text-decoration-none">
            <div className="card h-100 custom-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaBusinessTime className="icon" />
                </div>
                <h2 className="home-section-title mt-3">
                  Emprendimiento <FaArrowRight className="arrow-icon" />
                </h2>
                <p className="text-muted">
                  Herramientas y asesoría para potenciar tu negocio y alcanzar el éxito.
                </p>
                <ul className="list-unstyled custom-list">
                  <li>Asesoría técnica bilingüe</li>
                  <li>Cámaras de comercio locales</li>
                  <li>Vínculos con organizaciones</li>
                  <li>Herramientas de marketing</li>
                </ul>
              </div>
            </div>
          </Link>
        </div>
      </div>

      {/* Botón final (opcional, actualmente comentado) */}
      <div className="text-center mt-4">
        {/* <Link to="/choice" className="btn custom-btn">
          Regístrate y obtén resultados personalizados
        </Link> */}
      </div>
    </div>
  );
}

export default Sections;